import React from "react";

export const MenuIcon = () => {
  return (
    <>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0026 8.16667C12.7139 8.16667 11.6693 7.122 11.6693 5.83333C11.6693 4.54467 12.7139 3.5 14.0026 3.5C15.2913 3.5 16.3359 4.54467 16.3359 5.83333C16.3359 7.122 15.2913 8.16667 14.0026 8.16667Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: "1",
          }}
        />
        <path
          d="M14.0026 16.3327C12.7139 16.3327 11.6693 15.288 11.6693 13.9993C11.6693 12.7106 12.7139 11.666 14.0026 11.666C15.2913 11.666 16.3359 12.7106 16.3359 13.9993C16.3359 15.288 15.2913 16.3327 14.0026 16.3327Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: "1",
          }}
        />
        <path
          d="M14.0026 24.5007C12.7139 24.5007 11.6693 23.456 11.6693 22.1673C11.6693 20.8786 12.7139 19.834 14.0026 19.834C15.2913 19.834 16.3359 20.8786 16.3359 22.1673C16.3359 23.456 15.2913 24.5007 14.0026 24.5007Z"
          fill="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: "1",
          }}
        />
      </svg>
    </>
  );
};
